import { ButtonProps } from 'UI/Button/Button.types';
import * as S from './BackButton.styles';

const BackButton = (props: ButtonProps): JSX.Element => <S.Container {...props} />;

export default BackButton;
